import {fetchWithToken} from "./fetchWithToken";
import {Language} from "../model/Language";

const getBaseUrl = () => {
    let url;
    switch (process.env.NODE_ENV) {
        case 'production':
            url = '/api/testmails';
            break;
        case 'development':
            url = 'http://localhost:5000/api/testmails';
            break;
        default:
            url = '/api/testmails';
    }

    return url;
}

export async function sendTestmail(templateId: string, language?: Language) {
    try {
        const url = language ? `${getBaseUrl()}/${templateId}?language=${language}` : `${getBaseUrl()}/${templateId}`;
        const response = await fetchWithToken(url, {
            method: "POST"
        })
        return response
    } catch (error) {
        throw new Error("Error while sending Testmail")
    }
}

export async function sendSystemMailTestmail(customerId: string, templateId: string, language?: Language) {
    try {
        const url = language
            ? `${getBaseUrl()}/system/${customerId}/${templateId}?language=${language}`
            : `${getBaseUrl()}/system/${customerId}/${templateId}`;
        const response = await fetchWithToken(url, { method: "POST" });
        return response;
    } catch (error) {
        throw new Error("Error while sending system mail testmail");
    }
}

export async function sendCampaignTestmails(campaignId: string, language?: Language) {
    try {
        const url = language ? `${getBaseUrl()}/campaign/${campaignId}?language=${language}` : `${getBaseUrl()}/campaign/${campaignId}`;
        const response = await fetchWithToken(url, {
            method: "POST"
        })
        return response
    } catch (error) {
        throw new Error("Error while sending Testmails")
    }
}

export async function generateCampaignLearningLinks(campaignId: string, language?: Language) {
    try {
        const url = language ? `${getBaseUrl()}/campaign/${campaignId}/links?language=${language}` : `${getBaseUrl()}/campaign/${campaignId}/links`;
        const response = await fetchWithToken(url, {
            method: "POST"
        })
        return response
    } catch (error) {
        throw new Error("Error while sending Testmails")
    }
}


export async function generateLearningLinks(templateIds: string[], language?: Language) {
    try {
        const url = language ? `${getBaseUrl()}/links?language=${language}` : `${getBaseUrl()}/links`;
        const response = await fetchWithToken(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(templateIds)
        })
        return response
    } catch (error) {
        throw new Error("Error while generating Learninglinks")
    }
}